import * as React from 'react';
import ExploreSearchModule, {
  Props as SearchProps,
} from '../ExploreSearchModule/ExploreSearchModule';
import css from './ExploreHeroSection.module.scss';

interface Props extends React.HTMLProps<{}> {
  backgroudImageUrl: string;
  copy: string;
  // tslint:disable-next-line: no-any
  copyTag?: any;
  subCopy?: string;
  searchModule: SearchProps;
}

class ExploreHeroSection extends React.PureComponent<Props> {
  public render() {
    const { backgroudImageUrl, searchModule } = this.props;
    const CopyTag = this.props.copyTag || 'div';

    return (
      <section
        id="findMerchants"
        className={css.ExploreHeroSection}
        style={{
          backgroundImage: `url('${backgroudImageUrl}')`,
        }}
      >
        <div className={css.ExploreHeroSection__Filter}>
          <div className={css.ExploreHeroSection__Inner}>
            <CopyTag className={css.ExploreHeroSection__Copy}>
              {this.props.copy}
            </CopyTag>
            {this.props.subCopy && (
              <div className={css.ExploreHeroSection__SubCopy}>
                {this.props.subCopy}
              </div>
            )}
            <ExploreSearchModule {...searchModule} />
          </div>
        </div>
      </section>
    );
  }
}

export default ExploreHeroSection;
